import {useLayoutContext} from '../components/LayoutContextProvider';

export function useSnackbar() {
  const {openSnackbar} = useLayoutContext();

  return openSnackbar;
}
